import * as Icons from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, SectionHeading } from "./Reveal";
import { BUSINESS, FRANCHISE_ITEMS, IMAGES } from "@/lib/content";

const Icon = ({ name, className }) => {
  const C = Icons[name] || Icons.Circle;
  return <C className={className} />;
};

export const BusinessOpportunity = () => {
  return (
    <section id="business" className="py-[35px] lg:py-[50px] bg-[#FFFFFF]" data-testid="business-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-[45px] lg:gap-24 items-center">
          <Reveal className="order-2 lg:order-1">
            <div className="overflow-hidden rounded-[8px] aspect-[25/18]">
              <img
                src="https://customer-assets.emergentagent.com/job_discount-retail-hub-1/artifacts/rwgnxzqo_061ec842-ba4e-4801-b5c6-407319bbf05a%20%281%29.png"
                alt="Customers shopping in a bright, modern Home Cart retail space"
                className="h-full w-full object-cover"
                loading="lazy"
              />
            </div>
          </Reveal>

          <div className="order-1 lg:order-2">
            <SectionHeading align="left" eyebrow="The Home Cart Model" title="More Than Savings" />
            <Reveal delay={0.1}>
              <p className="font-body text-lg text-[#6B6B66] mt-[14px] lg:mt-[46px] leading-relaxed max-w-lg lg:max-w-xl">
                Home Cart combines a simple retail model with strong consumer
                demand for value-driven shopping — built around accessible
                operations, trusted product categories and a flexible format.
              </p>
            </Reveal>

            <div className="mt-[36px] lg:mt-10 grid sm:grid-cols-2 gap-x-10 gap-y-5">
              {BUSINESS.map((b, i) => (
                <Reveal key={b.title} delay={i * 0.07}>
                  <div
                    data-testid={`business-${i}`}
                    className="flex items-center gap-4"
                  >
                    <Icon
                      name={b.icon}
                      className="h-5 w-5 shrink-0 text-[#9A958C]"
                    />
                    <h3 className="font-heading text-base font-semibold text-[#1A1A1A] leading-snug">
                      {b.title}
                    </h3>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const Franchise = () => {
  return (
    <section className="py-[35px] lg:py-[50px] bg-white" data-testid="franchise-section">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Link
          to="/franchise"
          data-testid="franchise-cta"
          className="group block rounded-[18px] bg-[#F1F1F3] p-6 sm:p-12"
        >
          <div className="flex flex-col lg:flex-row lg:items-start gap-[25px] lg:gap-16">
            <div className="lg:w-[58%]">
              <h3 className="font-heading text-[31px] sm:text-5xl lg:text-[50px] lg:whitespace-nowrap font-medium tracking-tight text-[#1A1A1A] leading-[1.04]">
                Franchise Opportunities
              </h3>
              <p className="font-body text-base text-[#6B6B66] mt-[21px] lg:mt-[26px] leading-relaxed lg:max-w-lg">
                Learn how Home Cart works, what support is included and whether
                opening a Home Cart location is the right opportunity for you.
              </p>
              <span className="mt-[22px] lg:mt-7 inline-flex items-center justify-center gap-2 rounded-[5px] bg-[#F8B808] px-6 h-10 font-body text-sm font-medium text-[#1A1A1A] transition-all group-hover:bg-[#DD9F00]">
                Explore Franchise Opportunities
              </span>
            </div>

            <div className="flex-1 lg:mt-[72px]">
              <div className="grid grid-cols-2 gap-x-4 sm:gap-x-8 gap-y-3">
                {FRANCHISE_ITEMS.map((f, i) => (
                  <div
                    key={f.title}
                    data-testid={`franchise-item-${i}`}
                    className="flex items-center gap-2.5 py-1.5"
                  >
                    <Icons.Check className="h-4 w-4 shrink-0 text-[#F8B808]" />
                    <span className="font-body text-sm font-medium text-[#1A1A1A]">
                      {f.title}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};
